import React, { Component } from "react";
import { ColorPicker } from "antd";

class TextStyler extends Component {
  constructor(props) {
    super(props);
    const style = props.style || props;
    this.state = {
      color: style.color || "#000000",
      fontSize: style.fontSize || 16,
      bold: style.bold || false,
      italic: style.italic || false,
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      const style = this.props.style || this.props;
      this.setState({
        color: style.color || "#000000",
        fontSize: style.fontSize || 16,
        bold: style.bold || false,
        italic: style.italic || false,
      });
    }
  }

  handleColorChange = (color, hex) => {
    this.setState({ color: hex }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });
  };

  handleFontSizeChange = (e) => {
    const fontSize = parseInt(e.target.value) || 16;
    this.setState({ fontSize }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });
  };

  handleBoldToggle = () => {
    this.setState({ bold: !this.state.bold }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });
  };

  handleItalicToggle = () => {
    this.setState({ italic: !this.state.italic }, () => {
      if (this.props.onChange) {
        this.props.onChange(this.state);
      }
    });
  };

  render() {
    const { color, fontSize, bold, italic } = this.state;
    const { label, disabled, showPreview = true } = this.props;

    return (
      <div className="text-styler-container">
        {label && <label className="form-label d-block mb-2">{label}</label>}
        
        <div className="d-flex align-items-center gap-3 flex-wrap">
          {/* Color Picker */}
          <div>
            <label className="form-label mb-1" style={{ fontSize: "12px" }}>
              Color
            </label>
            <div>
              <ColorPicker
                value={color}
                onChange={this.handleColorChange}
                disabled={disabled}
                showText
              />
            </div>
          </div>

          {/* Font Size Input */}
          <div>
            <label className="form-label mb-1" style={{ fontSize: "12px" }}>
              Font Size
            </label>
            <div className="input-group" style={{ width: "100px" }}>
              <input
                type="number"
                className="form-control form-control-sm"
                value={fontSize}
                onChange={this.handleFontSizeChange}
                disabled={disabled}
                min="8"
                max="72"
              />
              <span className="input-group-text">px</span>
            </div>
          </div>

          {/* Bold Button */}
          <div>
            <label className="form-label mb-1" style={{ fontSize: "12px" }}>
              Bold
            </label>
            <div>
              <button
                type="button"
                className={`btn btn-sm ${bold ? "btn-primary text-white" : "btn-outline-primary"}`}
                onClick={this.handleBoldToggle}
                disabled={disabled}
                style={{
                  width: "40px",
                  fontWeight: "bold",
                  color: "#000",
                }}
              >
                B
              </button>
            </div>
          </div>

          {/* Italic Button */}
          <div>
            <label className="form-label mb-1" style={{ fontSize: "12px" }}>
              Italic
            </label>
            <div>
              <button
                type="button"
                className={`btn btn-sm ${italic ? "btn-primary text-white" : "btn-outline-primary"}`}
                onClick={this.handleItalicToggle}
                disabled={disabled}
                style={{
                  width: "40px",
                  fontStyle: "italic",
                  color: "#000",
                }}
              >
                I
              </button>
            </div>
          </div>
        </div>

        {/* Preview */}
        {showPreview && (
          <div className="mt-3 p-3 border rounded bg-light">
            <small className="text-muted d-block mb-1">Preview:</small>
            <div
              style={{
                color: color,
                fontSize: `${fontSize}px`,
                fontWeight: bold ? "bold" : "normal",
                fontStyle: italic ? "italic" : "normal",
              }}
            >
              {this.props.previewText || "Sample Text"}
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default TextStyler;

